import styled from 'styled-components';

import variables from '../../../styles/variables';

// GENERAL SCREEN STYLES
export const Phase3Screen = styled.div`
  width: 100%;
  height: auto;
  color: ${variables.colorBlack};
`;

export const BladeTitle = styled.h2`
  color: #eb0000;
  width: 100%;
  font-size: 43px;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0;
  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const BladeSubtitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.6;
  margin-bottom: 15px;
  &#listTitle {
    margin-bottom: 30px;
  }
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

export const SectionWrapper = styled.div`
  margin-top: 40px;
  &#doneButton {
    @media screen and (max-width: 768px) {
      text-align: center;
    }
  }
  @media screen and (max-width: 768px) {
    padding: 20px 0;
  }
`;

export const DetailSummary = styled.p`
  font-size: 38px;
  font-weight: 600;
  line-height: normal;
  /* margin-bottom: 20px; */
  @media screen and (max-width: 768px) {
    font-size: 39px;
  }
`;

export const ImgWrapper = styled.div`
  width: 85%;
  height: auto;
  margin: 30px 0;
  img {
    width: 100%;
    height: auto;
  }
  @media screen and (max-width: 768px) {
    width: 90%;
  }
  @media screen and (max-width: 450px) {
    width: 150%;
    position: relative;
    left: -50%;
  }
`;

// NEXT STEPS
export const List = styled.div`
  width: 100%;
`;

export const ListItemWrapper = styled.div`
  margin-bottom: 25px;
  display: grid;
  grid-template-columns: 40px 1fr;
  column-gap: 18px;
  align-items: center;
`;

export const ListImage = styled.div`
  display: inline-block;
  width: 38px;
  height: 38px;
  background-color: ${variables.colorRed};
  color: white;
  font-size: 20px;
  padding-top: 10px;
  padding-left: 1px;
  margin-right: 18px;
  text-align: center;
  border-radius: 50%;
`;

export const ListItem = styled.p`
  font-size: 18px;
  margin: 0;
  @media screen and (max-width: 768px) {
    font-size: 15px;
    line-height: 1.6;
  }
`;

// BUTTON
export const DoneButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 250px;
  height: 53px;
  margin-bottom: 20px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow:
    0 2px 4px 0 rgba(53, 43, 43, 0.24),
    0 2px 4px 0 rgba(238, 46, 36, 0.49);
  transition: all 0.3s;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }
  @media screen and (max-width: 768px) {
    width: 60%;
  }
`;

// FOOTER
export const CoName = styled.p`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const CoAddress = styled.p`
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 10px;
`;

export const CoSite = styled.p`
  a {
    font-size: 18px;
    font-weight: normal;
    text-decoration: none;
    color: ${variables.colorRed};
  }
`;
